import * as React from "react"
import { Link } from "gatsby"
import Header from "../components/Header/Header"
import Footer from "../components/Footer/Footer"
import { Container, Row, Col } from "react-bootstrap"
import { navigate } from "@reach/router";
import axios from "axios";
import { useState } from "react";


const getPropurl = async (handler, crmid) => {
    let result = [];
    //instead of hit REST we use json format to get only required fields. we dont import apollo since this call from another Hook
    var data = JSON.stringify({
        "query": "query($crm_id:[String]) { properties(where: { crm_id: $crm_id}) { id, slug, search_type, department } }",
        "variables": { "crm_id": [crmid] }
    });
    console.log("🚀 ~ file: 404.js ~ line 17 ~ getPropurl ~ data", data)
    var config = {
        method: 'post',
        url: `${process.env.GATSBY_STRAPI_SRC}/graphql`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`
        },
        data: data
    };
    const res = await axios(config);
    result[0] = JSON.stringify(res.data);
    handler(result);//update state var
}
// markup
const NotFoundPage = (props) => {
    const [showtemplate, setShowtemplate] = React.useState(false);
    const [propdata, setPropdata] = React.useState('');

    React.useEffect(() => {
        //we doing here as fallback, if any case build failed or not triggered then the below will be useful; when build happens redirects will happen a t netlify itself, so dont need to do CSR
        let regex = /[a-zA-Z]{3}[0-9]{6}/; //you can modify the preg as per proj feed
        if (props?.data?.property?.publish == false) {
            return setShowtemplate(true); // show 404 page template
        }
        if (props?.location?.pathname) {
            let crm_id = (props?.location?.pathname).match(regex);
            //mke sure state value is empty and we have proper url to proceed
            if (typeof crm_id != "undefined" && crm_id != null && crm_id.length > 0 && !propdata) {
                getPropurl(setPropdata, crm_id[0]); // call the function to fetch data from strapi
            } else if (propdata) {
                let property_data = JSON.parse(propdata);
                let property_arr = property_data.data.properties;
                if (property_arr.length > 0) {
                    let property = property_arr[0];
                    //set the redirection logic, same mentioned in the gatsby-node for _redirects.txt ie., crm_id to details page
                    if (property.department == 'residential') {
                        if (property.id) {
                            if (property.search_type == 'sales') {
                                navigate(`/property-for-sale/${property.slug}-${property.id}`, { replace: true });
                            }
                            else if (property.search_type == 'lettings') {
                                navigate(`/property-to-rent/${property.slug}-${property.id}`, { replace: true });
                            }
                        }
                    }
                    if (property.department == 'commercial') {
                        if (property.id) {
                            if (property.search_type == 'sales') {
                                navigate(`/commercial-property-for-sale/${property.slug}-${property.id}`, { replace: true });
                            }
                            else if (property.search_type == 'lettings') {
                                navigate(`/commercial-property-to-rent/${property.slug}-${property.id}`, { replace: true });
                            }
                        }
                    }
                    if (property.department == 'new_developments') {
                        if (property.id) {
                            if (property.search_type == 'sales') {
                                navigate(`/new-homes-for-sale/${property.slug}-${property.id}`, { replace: true });
                            }
                            else if (property.search_type == 'lettings') {
                                navigate(`/new-homes-to-rent/${property.slug}-${property.id}`, { replace: true });
                            }
                        }
                    }
                } else {
                    setShowtemplate(true);// show 404 page template
                }
            } else {
                setShowtemplate(true);// show 404 page template
            }
        }
    }, [propdata]);

    return (
        <div className="page-not-found">            
            <>
                <Header menuLinks={[]} />
                <div className="banner">
                    <div className="notfound-page">
                        <Container>
                            <div className="notfound-content">
                                {showtemplate ? 
                                    <>
                                    <h1>We’re sorry, the page you were looking for cannot be found.</h1>
                                    <p>This maybe because it has been removed, we’ve changed its name or it is temporarily unavailable.</p>
                                    </>
                                    :
                                    <p>Loading...</p>
                                }
                            </div>
                            <div className="banner-form mb-5">
                                <div className="input-box">
                                    <Link to={`/property/for-sale/`} className="btn subscribe-btn">Find a Property</Link>
                                    <Link to={`/`} className="btn subscribe-btn btn-red">Homepage</Link>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
                <Footer
                    popularSearch="Popular_Static" showBreadcrumb={true}
                />
            </>
        </div>
    )
}

export default NotFoundPage
